import React from 'react';
import './ServiceYardCareSeasons.css';

const seasons = [
  {
    label: 'Spring',
    title: 'Startup and prep',
    description:
      'Spring cleanup, irrigation startup, aeration, fertilization, and weed control. Getting your yard ready for the growing season before it gets away from you.',
    color: '#F6EDE4',
  },
  {
    label: 'Summer',
    title: 'Regular upkeep',
    description:
      'Mowing, edging, trimming, irrigation maintenance, and fertilization through the heat of the season. Your yard stays healthy and looking its best without you lifting a finger.',
    color: '#F3E7DD',
  },
  {
    label: 'Fall',
    title: 'Cleanup and care',
    description:
      'Fall cleanup, leaf removal, shrub trimming, aeration, and dethatching. Preparing your lawn and garden beds to come back strong in the spring.',
    color: '#F1E0D5',
  },
  {
    label: 'Winter',
    title: 'Winterization',
    description:
      'Full irrigation winterization and system blowout before the first freeze. Protecting your investment so nothing gets damaged over the cold months.',
    color: '#F5EAE0',
  },
];

const ServiceYardCareSeasons = () => (
  <section className="service-yard-care-seasons">
    <div className="service-yard-care-seasons__inner site-rail site-rail--wide">
      <header className="service-yard-care-seasons__header">
        <span className="service-yard-care-seasons__tag">THROUGH THE YEAR</span>
        <h2 className="service-yard-care-seasons__heading">
          Care for every
          <span className="service-yard-care-seasons__heading-accent"> Colorado season</span>
        </h2>
      </header>

      <div className="service-yard-care-seasons__cards">
        {seasons.map((season, index) => (
          <article
            key={season.label}
            className={`service-yard-care-seasons__card service-yard-care-seasons__card--${index + 1}`}
            style={{ backgroundColor: season.color }}
          >
            <span className="service-yard-care-seasons__card-label">{season.label}</span>
            <h3 className="service-yard-care-seasons__card-title">{season.title}</h3>
            <p className="service-yard-care-seasons__card-desc">{season.description}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default ServiceYardCareSeasons;
